/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import type {Klass, LexicalNode} from 'lexical';

import {AutoLinkNode, LinkNode} from '@lexical/link';
import { CustomParagraphNode } from './CustomParagraphNode';
// import { InlineBlockNode } from './InlineBlockNode';
import { StickyEditorNode } from './StickyEditorNode';
import { StickyImageNode } from './StickyImageNode';
import { InlineImageNode } from './InlineImageNode';
import { InlineYoutubeNode } from './InlineYoutube';
import { InlineEmbedNode } from './InlineEmbed';

const NEDNodes: Array<Klass<LexicalNode>> = [
  CustomParagraphNode,
  AutoLinkNode,
  LinkNode,
  // InlineBlockNode,
  StickyEditorNode,
  StickyImageNode,
  InlineImageNode,
  InlineYoutubeNode,
  InlineEmbedNode,
];

export default NEDNodes;
